import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
const Tincture = props => (
  <SvgIcon {...props}>
     <defs>
      <path d="M9,7.75 C8.86192881,7.75 8.75,7.86192881 8.75,8 L8.75,10 C8.75,10.1380712 8.86192881,10.25 9,10.25 L15,10.25 C15.1380712,10.25 15.25,10.1380712 15.25,10 L15.25,8 C15.25,7.86192881 15.1380712,7.75 15,7.75 L9,7.75 Z M9.75,11.75 L9,11.75 C8.03350169,11.75 7.25,10.9664983 7.25,10 L7.25,8 C7.25,7.03350169 8.03350169,6.25 9,6.25 L9.75,6.25 L9.75,3.5 C9.75,2.25735931 10.7573593,1.25 12,1.25 C13.2426407,1.25 14.25,2.25735931 14.25,3.5 L14.25,6.25 L15,6.25 C15.9664983,6.25 16.75,7.03350169 16.75,8 L16.75,10 C16.75,10.9664983 15.9664983,11.75 15,11.75 L14.25,11.75 L14.25,20.5 C14.25,21.7426407 13.2426407,22.75 12,22.75 C10.7573593,22.75 9.75,21.7426407 9.75,20.5 L9.75,11.75 Z M12.75,6.25 L12.75,3.5 C12.75,3.08578644 12.4142136,2.75 12,2.75 C11.5857864,2.75 11.25,3.08578644 11.25,3.5 L11.25,6.25 L12.75,6.25 Z M11.25,11.75 L11.25,20.5 C11.25,20.9142136 11.5857864,21.25 12,21.25 C12.4142136,21.25 12.75,20.9142136 12.75,20.5 L12.75,11.75 L11.25,11.75 Z" id="tincture-path-1" />
    </defs>
     <g id="Icon/Product/Tincture" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <mask id="tincture-mask-2" fill="white">
          <use href="#tincture-path-1" />
        </mask>
      <use id="Mask" fill={props.color} fillRule="nonzero" href="#tincture-path-1" />
      <g id="Color/Dark-Grey" mask="url(#tincture-mask-2)" fill={props.color}>
          <rect id="Rectangle" x="0" y="0" width="24" height="24" />
        </g>
    </g>
   </SvgIcon>
);

export default Tincture;



// WEBPACK FOOTER //
// ./src/icons/types/Tincture.jsx